import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container container">
        <div className="footer-content">
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <img
                src="/kids-vids-illustrated-logo.png"
                alt="KidsVids"
                className="footer-logo-image"
              />
            </Link>
            {/* <p className="footer-tagline">Capturing moments, creating memories.</p> */}
          </div>

          <div className="footer-links-group">
            <h4 className="footer-heading">Explore</h4>
            <nav className="footer-nav">
              <Link to="/about" className="footer-link">
                Our Story
              </Link>
              <a href="/#faq" className="footer-link">
                FAQ
              </a>
            </nav>
          </div>

          <div className="footer-links-group">
            <h4 className="footer-heading">Connect</h4>
            <nav className="footer-nav">
              <Link to="/enquiries" className="footer-link">
                Enquiries
              </Link>
            </nav>
            <div className="social-links">
              {/* Simple SVGs for social icons */}
              <a 
                href="https://www.instagram.com/kids_vids_editing/" 
                className="social-icon" 
                aria-label="Instagram"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                </svg>
              </a>
              <a 
                href="https://www.facebook.com/profile.php?id=61586761492262" 
                className="social-icon" 
                aria-label="Facebook"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
                </svg>
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} KidsVids. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
